import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import './leaderboard.css';

async function enableMocking(): Promise<void> {
  if (import.meta.env.DEV) {
    const { startMockWorker } = await import('@scoring/mocks');
    await startMockWorker();
  }
}

await enableMocking();

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
